import request from '@/utils/request'

// 优惠券活动分页列表
export function couponActivityPageList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/activity/pageList',
    method: 'POST',
    data,
  })
}

// 优惠券发放领取记录分页
export function userGetCouponPageList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/userGetCouponPageList',
    method: 'POST',
    data,
  })
}

// 优惠券核销记录分页
export function verifyCouponPageList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/verifyCouponPageList',
    method: 'POST',
    data,
  })
}

// 优惠券发放领取记录导出
export function userGetCouponPageExport(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/userGetCouponPageExport',
    method: 'POST',
    responseType: 'blob',
    isExport: true,
    data,
  })
}

// 优惠券核销记录导出
export function userVerifyCouponPageExport(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/userVerifyCouponPageExport',
    method: 'POST',
    responseType: 'blob',
    isExport: true,
    data,
  })
}

// 优惠券模板统计详情
export function couponTemplateStatistics(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/couponTemplateStatistics',
    method: 'POST',
    data,
  })
}

// 优惠券核销抵扣明细
export function verifyCouponDetailList(data = {}) {
  return request({
    // baseURL: 'https://mock-test.cheweijia.com/mock/10282',
    url: '/admin/v1/vehicle/coupon/verifyCouponDetailList',
    method: 'POST',
    data,
  })
}

/**
 * @typedef {Object} CampaignQueryParams
 * @property {string} [activityName] - 活动名称（模糊匹配）
 * @property {string} [activityState] - 活动状态
 * @property {string} [startDate] - 开始日期 (yyyy-MM-dd)
 * @property {string} [endDate] - 结束日期 (yyyy-MM-dd)
 * @property {number} [pageNum] - 页码
 * @property {number} [pageSize] - 每页数量
 */

/**
 * @typedef {Object} CampaignItem
 * @property {number} id - 活动ID
 * @property {string} activityName - 活动名称
 * @property {string} startDate - 活动开始日期 (yyyy-MM-dd)
 * @property {string} endDate - 活动结束日期 (yyyy-MM-dd)
 * @property {number} preFreeRentDays - 前置免租天数
 * @property {number} presentDays - 满租赠送天数
 * @property {number} planCount - 关联方案个数
 * @property {number} activityState - 活动状态 0:未开始 1:进行中 2:已过期 3:已失效
 * @property {string} gmtCreate - 创建时间 (yyyy-MM-dd HH:mm:ss)
 */

/**
 * @typedef {Object} CampaignListResponse
 * @property {number} pageNum
 * @property {number} pageSize
 * @property {number} totalNum
 * @property {number} totalPage
 * @property {CampaignItem[]} items
 */

/**
 * 获取租期赠送活动列表
 * @param {CampaignQueryParams} data - 查询参数
 * @returns {Promise<{code: number, data: CampaignListResponse, msg: string}>}
 */
export function getCampaignList(data) {
  return request({
    url: '/admin/v1/vehicle/presentActivity/list',
    method: 'POST',
    data,
  })
}

/**
 * @typedef {Object} CampaignDetail
 * @property {number} id - 活动ID
 * @property {string} activityName - 活动名称
 * @property {string} startDate - 活动开始日期 (yyyy-MM-dd)
 * @property {string} endDate - 活动结束日期 (yyyy-MM-dd)
 * @property {number} preFreeRentDays - 前置免租天数
 * @property {number} presentDays - 满租赠送天数
 * @property {number} activityState - 活动状态 0:未开始 1:进行中 2:已过期 3:已失效
 * @property {{ planId: number, planName: string }[]} planList - 关联方案列表
 */

/**
 * 获取租期赠送活动详情
 * @param {{ id: number }} data - 活动ID
 * @returns {Promise<{code: number, data: CampaignDetail, msg: string}>}
 */
export function getCampaignDetail(data) {
  return request({
    url: '/admin/v1/vehicle/presentActivity/detail',
    method: 'POST',
    data,
  })
}

/**
 * @typedef {Object} CampaignSaveParams
 * @property {number} [id] - 活动ID（编辑时传，新增不传）
 * @property {string} activityName - 活动名称
 * @property {string} startDate - 活动开始日期 (yyyy-MM-dd)
 * @property {string} endDate - 活动结束日期 (yyyy-MM-dd)
 * @property {number} preFreeRentDays - 前置免租天数（>=0）
 * @property {number} presentDays - 满租赠送天数（>=0）
 * @property {number[]} planIdList - 关联方案ID列表（至少1个）
 */

/**
 * 保存租期赠送活动（新增/编辑）
 * @param {CampaignSaveParams} data - 活动数据，传 id 为编辑，不传为新增
 * @returns {Promise<{code: number, data: number, msg: string}>} data 为活动ID
 * @description 冲突校验由后端 save 接口内部处理，冲突时返回错误 msg
 */
export function saveCampaignSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/presentActivity/v2/save',
    method: 'POST',
    data,
    signParams: ['activityName', 'preFreeRentDays', 'presentDays', 'planIdList[0]'],
  })
}

/**
 * 租期赠送活动上架/下架
 * @param {{ id: number, activityState: number }} data - id: 活动ID, activityState: 0=下架 1=上架
 * @returns {Promise<{code: number, data: boolean, msg: string}>}
 */
export function updateCampaignStateSignCheck(data) {
  return request({
    url: '/admin/v1/vehicle/presentActivity/v2/updateState',
    method: 'POST',
    data,
    signParams: ['id', 'activityState'],
  })
}

/**
 * 删除租期赠送活动
 * @param {{ id: number }} data - 活动ID
 * @returns {Promise<{code: number, data: boolean, msg: string}>}
 */
export function deleteCampaign(data) {
  return request({
    url: '/admin/v1/vehicle/presentActivity/delete',
    method: 'POST',
    data,
  })
}

/**
 * 检查方案是否与其他进行中活动冲突
 * @param {{ planId: number, excludeCampaignId?: number }} data
 *   planId: 方案ID
 *   excludeCampaignId: 排除的活动ID（编辑时传当前活动ID）
 * @returns {Promise<{code: number, data: Object, msg: string}>}
 */
export function checkPlanCampaignConflict(data) {
  return request({
    url: '/admin/v1/vehicle/presentActivity/checkPlanConflict',
    method: 'POST',
    data,
  })
}
